import { FormWithRedux } from '../../FormWithRedux';

export class ACCBISTInformationForm extends FormWithRedux {

    constructor() {
        super('introForm');
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-IntroForm.js